import React from 'react';

const Container = ({ children, maxWidth = 'max-w-7xl', padding = 'px-2 sm:px-4 lg:px-8 py-4' }) => {
    return (
        <div className={`${maxWidth} mx-auto ${padding}`}>
            {children}
        </div>
    );
}

export default Container;
